module.exports = __webpack_public_path__ + "static/sport/bgi-form.7875154.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/trea/bgi-form.png
// module id = GruS
// module chunks = 0